import _ from "lodash";
import { tViews } from "../../../../utils/table";
import { isFreqNow, isDaily, getRepeatOnDay } from "../../../../utils/common";
import {
  shortDisplayTimeOnly,
  shortDisplayDateFullYear
} from "../../../../utils/displayTime";
import { displayFullMonth } from "../../../../utils/displayTime";
import { tCommon } from "../../../../utils/table";
import { SCHEDULE_TYPE } from "../../../../utils/enums";
// get table columns configuration for the flow tab
// This function returns an array of column configurations for the flow table

export const replaceSpecialCharacters = (inputString) => {
  // The 'g' flag indicates a global search, meaning all occurrences will be replaced.
  const regex = /[.:]/g;

  return inputString.replace(regex, '_');
};

export const getTableColumns = (handleActionClick, handleCopyPassKey, openTableSettings, registerDeleteButton) => {
  const tableColumns = [
    {
      prop: "report_name",
      name: tViews('reporTableColReportNameLabel'),
      sortable: true,
      size: 280, 
      cellTemplate: (createElement, props) => {
         const uniqueId = replaceSpecialCharacters(props.model.report_name);
        const content = createElement("div", {
          class: "hbr-css__table-cell-align-center", 
          innerHTML: `
          <div id="my-unique-cell-id-${uniqueId}" class="overflow-ellipsis">${props.model.report_name}</div>
          <hbr-portal>
            <hbr-tooltip class="report-table-name-tooltip" anchor="#my-unique-cell-id-${uniqueId}">
              <div slot="content">
                  ${props.model.report_name}
              </div>
            </hbr-tooltip>
          </hbr-portal> `,
        });
        return content;
      } 
    },
    {
      prop: "schedule_type",
      name: tViews('reporTableColScheduleLabel'),
      sortable: true,
      size: 250, 
      columnProperties: ({ prop }) => ({ "data-testid": `header_${prop}` }),
      cellProperties: ({ prop }) => ({ "data-testid": `cell_${prop}` }),
       cellTemplate: (createElement, props) => {
        const freq = props.model.schedule_freq;
        let htmlContent = '';
        if (isFreqNow(props.model.schedule_freq)) {
        htmlContent = `<div style='display: "flex",flexDirection: "column",justifyContent: "center",overflow: "hidden"'>
          ${tViews('workflowOneTimeNow')}
          <br/>
          <span class='next-run'> on 
            ${displayFullMonth(props.model.next_run)} at ${shortDisplayTimeOnly(props.model.next_run)}
          </span><br/></div>
        `;
      } else if (isDaily(props.model.schedule_freq)) {
        htmlContent = `<div>
          ${freq.charAt(0).toUpperCase()}${freq.substring(1)}
          <br/>
          <span class='next-run'> 
            on ${shortDisplayDateFullYear(props.model.repeat_time)} at ${shortDisplayTimeOnly(props.model.repeat_time)}
          </span></div>
        `;
      } else {
        htmlContent = `<div>
          ${typeof freq === "string" && freq.length > 0 ? freq.charAt(0).toUpperCase() + freq.substring(1) : ""}
          <br/>
          <span class='next-run'> on ${getRepeatOnDay(props.model.repeat_on)} at ${shortDisplayTimeOnly(props.model.repeat_time)}</span></div>
        `;
      } 
        const content = createElement("div", {
          class: "hbr-css__table-cell-align-center",
          innerHTML: htmlContent,
        }); 
       return content;   
      }  
    },
    {
      prop: "last_run",
      name: tViews('reporTableColLastRunLabel'),
      sortable: true,
      size: 200,
      columnProperties: ({ prop }) => ({ "data-testid": `header_${prop}` }),
      cellProperties: ({ prop }) => ({ "data-testid": `cell_${prop}` }), 
      cellTemplate: (createElement, props) => {
        let content = "--";
        if (Number.isInteger(props.model.last_run)) {
          content = shortDisplayDateFullYear(props.model.last_run);
          if (props.model.last_run !== 0) {
            content += ` at ${shortDisplayTimeOnly(props.model.last_run)}`;
          }
        }
        return createElement("div", {
          class: "hbr-css__table-cell-align-center",
          innerHTML: content,
        });
      }
    },
    {
      prop: "report_count",
      name: tViews('reporTableColCountLabel'),
      sortable: true,
      size: 120,
      columnProperties: ({ prop }) => ({ "data-testid": `header_${prop}` }),
      cellProperties: ({ prop }) => ({ "data-testid": `cell_${prop}`}),
      cellTemplate: (createElement, props) => {
        let htmlContent = 0;
        if (Number.isInteger(props.model.report_count)) {
          htmlContent = props.model.report_count;
        }  
        return createElement("div", {
          class: "hbr-css__table-cell-align-center",
          innerHTML: htmlContent, 
        });
      }       
    },
    {
      prop: "report_passkey",
      name: tViews('reporTableColDocKeyLabel'),
      size: 300,
      cellProperties: ({ prop }) => ({ "data-testid": `cell_${prop}` }), 
      cellTemplate: (createElement, props) => { 
        let htmlContent = "--";
        if (!_.isEmpty(props.model.report_passkey)) {
          htmlContent =  `<div class="passkey-row" data-cy="copyActions"> 
          <hbr-icon-button name="copy" class="copyPassword" arialabel="${tViews('a11yLabels.workflowCopyPasskey')}"></hbr-icon-button>    
          <hbr-input type="password" value=${props.model.report_passkey}  toggle-password=true ></hbr-input>          
          </div>`;
        } else {
           htmlContent =  `<div>--</div>`;
        }
        return createElement("div", {
          class: "hbr-css__table-cell-align-center",
          innerHTML: htmlContent,
          onClick: e => {            
            if (e && e.target && e.type === "click") { 
               e.preventDefault(); 
                if (e.target.name ==="copy") { 
                navigator.clipboard.writeText(props.model.report_passkey);
                handleCopyPassKey(e,props.model.report_id);
              }
            }
          },            
        });
      }
    },
    {
      prop: "recipient_email",
      name: tViews('reporTableColDeliveryLabel'),
      sortable: true,
      size: 320,  
      cellTemplate: (createElement, props) => {        
        const htmlContent = `<div class="recipient-email-row" data-cy="copyActions"> 
        <hbr-tag name="copy">${props.model.file_type}</hbr-tag> 
        </div> 
          <div id="my-unique-cell-email-id-${props.rowIndex}" class="overflow-ellipsis">${props.model.recipient_email.split("|").join(", ")}</div>
          <hbr-portal>
            <hbr-tooltip class="report-table-name-tooltip" anchor="#my-unique-cell-email-id-${props.rowIndex}">
              <div slot="content">
                  ${props.model.recipient_email.split("|").join(", ")}
              </div>
            </hbr-tooltip>
          </hbr-portal>`; 
        const content = createElement("div", {
          class: "hbr-css__table-cell-align-center",
          innerHTML: htmlContent,
        });
        return content;
      }
    },
    {
      prop: "template_name",
      name: tViews('reportTemplate'),
      sortable: true,
      size: 200,
      columnProperties: ({ prop }) => ({ "data-testid": `header_${prop}` }),
      cellProperties: ({ prop }) => ({ "data-testid": `cell_${prop}`,class: { "hbr-css__table-cell-align-center": true } }), 
    },
    {
      prop: "action",
      name: tViews('reporTableActions'),
      size: 140,
      disableToggle: true,
      sortable: false,
      columnProperties: ({ prop }) => ({ "data-testid": `header_${prop}` }),
      cellProperties: ({ prop }) => ({ "data-testid": `cell_${prop}` }),
      cellTemplate: (createElement, props) => {
        const isViewOnly = props.model.schedule_type === SCHEDULE_TYPE.ONCE;
        return [createElement("div", {
          class: "hbr-css__table-cell-align-center", 
          onClick: e => {
            if (e && e.target) {
               e.preventDefault();
               handleActionClick(e);
            }
          } 
        }, [
          createElement("div", {
            class: "action-row"
          }, [
            createElement("hbr-icon-button", {
              name: isViewOnly ? "eye" : "pencil-simple",
              size: "20px",
              arialabel: isViewOnly ? "view" : "edit",
              "data-btnname": "edit",
              "data-reportid": props.model.report_uuid,
              "data-reportmode": isViewOnly ? "view" : "edit",
              "data-pagename": props.model.template_name || props.model.page_name
            }),
            createElement("hbr-icon-button", {
              name: "trash-simple",
              arialabel: "delete",
              size: "20px",
              "data-btnname": "delete",
              "data-reportid": props.model.report_uuid,
              "data-reportname": props.model.report_name,
              "data-rowindex": props.rowIndex,
              ref: element => registerDeleteButton?.(props.rowIndex, element)
            })
          ])
        ])];
      } 
    },
    
  ]; 
  if (typeof openTableSettings === "function") {
    tableColumns.push({
      prop: "actions",
      name: "Actions",
      hiddenText: "Actions",
      disableToggle: true,
      sortable: false,
      headerSlot: false,
      pin: "colPinEnd",
      size: 70,
      columnTemplate: (createElement) => {
        return createElement("hbr-icon-button", {
          name: "gear-six-outlined",
          class: "hbr-css__table-cell-align-center gear-icon",
          aria: { label: tCommon('tableSettings') },
          "data-testid": "settings-generated-reports-table",
          onClick: (evt) => {
            evt.stopPropagation();
            openTableSettings();
          }
        });
      }
    });
  }
  for (const item of tableColumns)
    Object.assign(item, {
      id: item.prop,
      sortable: typeof item.sortable === "boolean" ? item.sortable : (item.prop !== "action" && item.prop !== "actions")
    }); 
  return tableColumns;
};

export const setReportsData = data => {
  return (Array.isArray(data) ? data : []).map((item) => {
    const freq = item.schedule_freq;
    let scheduleType = "";
    if (isFreqNow(freq)) {
      scheduleType = `${tViews('workflowOneTimeNow')} on ${displayFullMonth(item.next_run)} at ${shortDisplayTimeOnly(item.next_run)}`;
    } else if (isDaily(freq)) {
      scheduleType = `${freq.charAt(0).toUpperCase()}${freq.substring(1)} on ${shortDisplayDateFullYear(item.repeat_time)} at ${shortDisplayTimeOnly(item.repeat_time)}`;
    } else {
      scheduleType = `${typeof freq === "string" && freq.length > 0 ? freq.charAt(0).toUpperCase() + freq.substring(1) : ""} on ${getRepeatOnDay(item.repeat_on)} at ${shortDisplayTimeOnly(item.repeat_time)}`;
    }

    let lastRun = "--";
    if (Number.isInteger(item.last_run)) {
      lastRun = shortDisplayDateFullYear(item.last_run);
      if (item.last_run !== 0) {
        lastRun += ` at ${shortDisplayTimeOnly(item.last_run)}`;
      }
    }

    return {
      ...item,
      schedule_type: scheduleType,
      last_run: lastRun,
      report_count: Number.isInteger(item.report_count) ? item.report_count : 0,
      report_passkey: _.isEmpty(item.report_passkey) ? "--" : item.report_passkey,
      recipient_email: item.recipient_email?.split("|").join(", ") || ""
    };
  });
};
